$(document).on "turbolinks:load", ->
  $(".navbar-burger").click ->
      $(".navbar-burger").toggleClass "is-active"
      $(".navbar-menu").toggleClass "is-active"
